import styled from 'styled-components';

/** Page column — sections stack with the source's 12px gap inside the layout slot. */
export const AcqPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
